import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

const emergencyText =
  "Atlanta ~90 mi via I-75 (1.5+ hrs in perfect conditions). Georgia has only ONE passport agency (Atlanta) serving 11M+ statewide residents. Dalton is the Carpet Capital of the World — flooring industry executives making last-minute trips to international trade shows in Hannover, Germany or Shanghai cannot afford to gamble on Atlanta's single agency. I-75 through northwest Georgia has no viable alternate route — a single accident between Dalton and Atlanta adds hours with zero detour options through the Cohutta Wilderness. Spring tornado season (March–May) has produced EF-3+ tornadoes crossing I-75 in Whitfield County — when the interstate closes, Dalton is severed from Atlanta's only agency.";

const disclaimerText =
  "*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing.";

export default function DaltonProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Dalton"
      headingExtra="GA"
      introText="Dalton and northwest Georgia travelers — flooring industry executives heading to international trade shows, manufacturing partners visiting overseas mills, and Whitfield County families on mission trips — have several options for getting a passport fast. Here's how they compare, and why most northwest Georgia residents choose a registered U.S. Department of State courier for predictable, professional processing."
      options={options}
      emergencyDescription={emergencyText}
      disclaimerText={disclaimerText}
    />
  );
}